export function IconGlobalSourcing() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="#F5B400" strokeWidth="2" />
      <path d="M3 12H21" stroke="#F5B400" strokeWidth="2" />
      <path
        d="M12 3C14.5 5.5 16 8.5 16 12C16 15.5 14.5 18.5 12 21"
        stroke="#F5B400"
        strokeWidth="2"
      />
      <path
        d="M12 3C9.5 5.5 8 8.5 8 12C8 15.5 9.5 18.5 12 21"
        stroke="#F5B400"
        strokeWidth="2"
      />
    </svg>
  )
}

export function IconQualityAssurance() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2L20 6V12C20 17 16.5 20.5 12 22C7.5 20.5 4 17 4 12V6L12 2Z"
        stroke="#F5B400"
        strokeWidth="2"
      />
      <path d="M9 12L11 14L15 10" stroke="#F5B400" strokeWidth="2" />
    </svg>
  )
}

export function IconTimelyDelivery() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2" y="6" width="12" height="8" stroke="#F5B400" strokeWidth="2" />
      <path d="M14 8H18L21 11V14H14V8Z" stroke="#F5B400" strokeWidth="2" />
      <circle cx="7" cy="17" r="2" stroke="#F5B400" strokeWidth="2" />
      <circle cx="17" cy="17" r="2" stroke="#F5B400" strokeWidth="2" />
    </svg>
  )
}

export function IconCustomerCommitment() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M8 12L4 8C2.5 6.5 2.5 4 4 2.5C5.5 1 8 1 9.5 2.5L12 5L14.5 2.5C16 1 18.5 1 20 2.5C21.5 4 21.5 6.5 20 8L16 12"
        stroke="#F5B400"
        strokeWidth="2"
      />
      <path d="M6 13L12 19L18 13" stroke="#F5B400" strokeWidth="2" />
    </svg>
  )
}
